// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"126":"a95b81c4","356":"f822d4e2","406":"733f5596","486":"f822d4e2","772":"f822d4e2"}[chunkId] + ".chunk.css";
};